export default function run_enhanced_conversion(form, response_obj) {

    const form_id = form.getAttribute('data-form-id');
    const email = document.getElementById('f-form1-Email') || document.getElementById('f-form2-Email');
    
    const demo_form_ids = ['1020', '1056', '1057', '1055'];
    const content_download_form_ids = ['1441', '1045', '1044', '1046'];

    if (demo_form_ids.includes(form_id)) {
        console.log('Sending ' + email.value + ' to enhanced conversion from demo form');
        window.dataLayer.push({
            'event':'form2',
            'enhanced_conversion_data': {
                "email": email.value,   
            }
        });
    }
    else if (content_download_form_ids.includes(form_id)) {
        console.log('Sending ' + email.value + ' to enhanced conversion from content download form');
        window.dataLayer.push({
            'event':'purchase_enhanced_conversion',
            'enhanced_conversion_data': {
              "email": email.value,   
            }
        });
    }
}
